import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Email from "@mui/icons-material/Email";
import Call from "@mui/icons-material/Call";
import "./Footer.css";

const Footer = () => {
  return (
    <div style={{ backgroundColor: "rgba(0, 0, 0, 0.7)", marginTop: "0px" }}>
      <Grid sx={{ color: "rgba(255, 255, 255,0.8)", m: 0, py: 5 }}>
        <Grid xs={12} md={12}>
          <Typography variant="h4" component="div" gutterBottom>
            Let’s work together
          </Typography>

          <Box sx={{ fontFamily: "Monospace" }} className="footer-container">
            {/* <span style={{ paddingRight: "50px" }}> */}
            <p> <Call className="phone-container"></Call> 01789427394  </p> 
            <br />
            <Email className="email-container" /> mr.ashraful2020@gmail.com
          </Box>
        </Grid>

        {/* <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="h2">Hello</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h2">Hello3</Typography>
          </Grid>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default Footer;
